import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { getListCard, getTrackingLink } from "../../services/CardService";
import check from "../../assets/icons/mdi_check.svg";
import star from "../../assets/icons/5-star-ic.svg";
import creaditCartRed from "../../assets/images/tpbank_red.png";
import creaditCartBlue from "../../assets/images/tpbank_blue.png";
import creaditCartPurple from "../../assets/images/tpbank_purple.png";

const FALLBACK_CARD_IMAGES = [
  creaditCartRed,
  creaditCartBlue,
  creaditCartPurple,
];
const CARDS_PER_PAGE = 6;

const formatCurrencyVND = (value) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  if (typeof value === "number") {
    try {
      return `${value.toLocaleString("vi-VN")} VNĐ`;
    } catch (error) {
      return `${value} VNĐ`;
    }
  }

  const numericValue = Number(value);
  if (!Number.isNaN(numericValue) && value !== "") {
    try {
      return `${numericValue.toLocaleString("vi-VN")} VNĐ`;
    } catch (error) {
      return `${numericValue} VNĐ`;
    }
  }

  return value;
};

const parseBenefits = (benefits) => {
  if (Array.isArray(benefits)) {
    return benefits
      .map((item) => (typeof item === "string" ? item.trim() : item))
      .filter(Boolean);
  }

  if (typeof benefits === "string") {
    return benefits
      .split(/[\n|,;]+/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
};

const extractCardList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data?.content)) {
    return payload.data.content;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.content)) {
    return payload.content;
  }

  return [];
};

const convertFuturesCardCode = (code) => {
  const codeMap = {
    PDC: "Tỷ lệ phê duyệt cao",
    CTO: "Chi tiêu Online",
    RT: "Rút tiền",
  };
  return codeMap[code] || code;
};

const CardProduct = ({ card, index }) => {
  const cardName = card?.registerDeeplink?.name ?? card?.name ?? "Thẻ tín dụng";
  const tagLine = card?.registerDeeplink?.tag ?? "Ưu đãi hấp dẫn";
  const maxLimitRaw = card?.registerDeeplink?.limit;
  const maxLimit = formatCurrencyVND(maxLimitRaw) || "Đang cập nhật";
  const giftRaw = card?.registerDeeplink?.gift;
  const gift = formatCurrencyVND(giftRaw) || "Đang cập nhật";
  const annualFeeRaw = card?.registerDeeplink?.annualFee;
  const annualFee = formatCurrencyVND(annualFeeRaw) || "Đang cập nhật";
  const imageSrc =
    card?.registerDeeplink?.imgProduct ||
    FALLBACK_CARD_IMAGES[index % FALLBACK_CARD_IMAGES.length];
  const cardId = card?.id;
  const detailUrl =
    card?.registerDeeplink?.detailUrl ??
    card?.registerDeeplink?.url ??
    (cardId
      ? `/dich-vu/mo-the/card-info/${cardId}`
      : "/dich-vu/mo-the/card-info");
  const applyUrl = card?.registerDeeplink?.link;
  const benefitsRaw = parseBenefits(card?.registerDeeplink?.futuresCard);
  const benefits = benefitsRaw.map((benefit) =>
    convertFuturesCardCode(benefit)
  );

  // Lấy tối đa 3 phần tử, nếu thiếu thì để trống
  const displayBenefits = benefits.slice(0, 3);

  const cardKey =
    card?.id ??
    card?.cardId ??
    card?.cardCode ??
    card?.code ??
    card?.slug ??
    index;
  const isExternalDetail =
    typeof detailUrl === "string" && detailUrl.startsWith("http");

  const applyButtonProps = applyUrl
    ? {
        onClick: () => {
          if (typeof window !== "undefined") {
            window.open(applyUrl, "_blank", "noopener,noreferrer");
          }
        },
      }
    : {
        "data-bs-target": "#notificationModal",
        "data-bs-toggle": "modal",
      };

  const infoRows = [
    {
      label: "Hạn mức tối đa:",
      value: maxLimit || "Đang cập nhật",
    },
    {
      label: "Quà tặng:",
      value: gift || "Đang cập nhật",
    },
    {
      label: "Ưu đãi phí thường niên:",
      value: annualFee || "Đang cập nhật",
    },
  ];

  return (
    <div className="col-sm-4 product">
      <div className="img-product">
        <img src={imageSrc} alt={cardName} className="card-image" />
      </div>

      <div className="content-product">
        <div className="title-product">
          <h3 className="name-product">{cardName}</h3>
          <span className="tag">
            <img src={star} alt="star" className="star" /> {tagLine}
          </span>
        </div>
        <div className="price-product">
          {infoRows.map((info, infoIndex) => (
            <div className="price-info" key={`${cardKey}-info-${infoIndex}`}>
              <span className="text-price">{info.label}</span>
              <span className="highlight">{info.value}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="divier"></div>

      <div className="tieuchi-product">
        {displayBenefits.map((benefit, benefitIndex) => (
          <div
            className="tieuchi-product-item"
            key={`${cardKey}-benefit-${benefitIndex}`}
          >
            <div className="check-icon">
              <img src={check} alt="check" className="check" />
            </div>
            <div className="tieuchi-product-text">{benefit}</div>
          </div>
        ))}
      </div>

      <div className="btn-actions">
        <button className="btn-custom" {...applyButtonProps}>
          Mở thẻ ngay
        </button>
        {isExternalDetail ? (
          <a
            href={detailUrl}
            className="btn-secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tìm hiểu thêm
          </a>
        ) : (
          <Link to={detailUrl} className="btn-secondary">
            Tìm hiểu thêm
          </Link>
        )}
      </div>
    </div>
  );
};

const RegisterCardSection = () => {
  const [activeTab, setActiveTab] = useState("Tất cả");
  const [cards, setCards] = useState([]);
  const [isLoadingCards, setIsLoadingCards] = useState(true);
  const [activePage, setActivePage] = useState(1);
  const [salaryInput, setSalaryInput] = useState("");
  const [ageInput, setAgeInput] = useState("");
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedSort, setSelectedSort] = useState(null);

  const parseNumber = (value) => {
    if (value === undefined || value === null) return null;
    const numeric = String(value).replace(/[^\d]/g, "");
    if (!numeric) return null;
    const parsed = Number(numeric);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const getFilteredCards = () => {
    let result = cards;

    // Filter theo tab (codeMap PDC/CTO/RT)
    if (activeTab !== "Tất cả") {
      const tabCodeMap = {
        "Tỉ lệ phê duyệt cao": "PDC",
        "Chi tiêu Online": "CTO",
        "Rút tiền": "RT",
      };

      const filterCode = tabCodeMap[activeTab];
      if (filterCode) {
        result = result.filter((card) => {
          const benefitsRaw = parseBenefits(
            card?.registerDeeplink?.futuresCard
          );
          return benefitsRaw.some((benefit) => benefit === filterCode);
        });
      }
    }

    // Filter theo thu nhập
    const salary = parseNumber(salaryInput);
    if (salary !== null) {
      result = result.filter((card) => {
        const incomeMinRaw = card?.registerDeeplink?.incomeMin;
        const incomeMin = parseNumber(incomeMinRaw);
        if (incomeMin === null) return true; // nếu thiếu dữ liệu thì không loại bỏ
        return salary >= incomeMin;
      });
    }

    // Filter theo tuổi
    const age = parseNumber(ageInput);
    if (age !== null) {
      result = result.filter((card) => {
        const deeplink = card?.registerDeeplink || {};
        const minAge =
          deeplink.minAge !== undefined && deeplink.minAge !== null
            ? Number(deeplink.minAge)
            : null;
        const maxAge =
          deeplink.maxAge !== undefined && deeplink.maxAge !== null
            ? Number(deeplink.maxAge)
            : null;

        if (minAge !== null && age < minAge) return false;
        if (maxAge !== null && age > maxAge) return false;
        return true;
      });
    }

    // Filter theo khu vực
    if (selectedArea?.value) {
      const selectedCity = selectedArea.value;
      result = result.filter((card) => {
        const screenCity = card?.registerDeeplink?.screenCity;
        if (!screenCity || screenCity === "Toàn quốc") return true;
        return String(screenCity).includes(selectedCity);
      });
    }

    // Sắp xếp
    if (selectedSort?.value) {
      const sortValue = selectedSort.value;
      const sorted = [...result];

      const getLimit = (card) =>
        parseNumber(card?.registerDeeplink?.limit) ?? 0;

      const getName = (card) =>
        card?.registerDeeplink?.name ?? card?.name ?? "";

      const getTime = (card) => {
        const dateStr =
          card?.createdDate || card?.updatedDate || card?.createdAt;
        const time = dateStr ? new Date(dateStr).getTime() : 0;
        return Number.isNaN(time) ? 0 : time;
      };

      switch (sortValue) {
        case "priceAsc":
          sorted.sort((a, b) => getLimit(a) - getLimit(b));
          break;
        case "priceDesc":
          sorted.sort((a, b) => getLimit(b) - getLimit(a));
          break;
        case "nameAsc":
          sorted.sort((a, b) => getName(a).localeCompare(getName(b), "vi"));
          break;
        case "nameDesc":
          sorted.sort((a, b) => getName(b).localeCompare(getName(a), "vi"));
          break;
        case "newest":
          sorted.sort((a, b) => getTime(b) - getTime(a));
          break;
        case "oldest":
          sorted.sort((a, b) => getTime(a) - getTime(b));
          break;
        default:
          break;
      }

      result = sorted;
    }

    return result;
  };

  const filteredCards = getFilteredCards();

  const customSelect = {
    control: (provided, state) => ({
      ...provided,
      width: "237px",
      height: "50px",
      borderRadius: "5px",
      borderColor: state.isFocused ? "#2563eb" : "#d0d5dd",
      backgroundColor: "rgba(217, 217, 217, 0.3)",
      "&:hover": {
        borderColor: "#2563eb",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#B0B7C4",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#344054",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#2563eb",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  const optionArea = [
    { value: "Hà Nội", label: "Hà Nội" },
    { value: "TP. Hồ Chí Minh", label: "TP. Hồ Chí Minh" },
    { value: "Đà Nẵng", label: "Đà Nẵng" },
    { value: "Hải Phòng", label: "Hải Phòng" },
    { value: "Cần Thơ", label: "Cần Thơ" },
  ];

  const sortBy = [
    { value: "newest", label: "Mới nhất" },
    { value: "oldest", label: "Cũ nhất" },
    { value: "priceAsc", label: "Giá tăng dần" },
    { value: "priceDesc", label: "Giá giảm dần" },
    { value: "nameAsc", label: "Tên A → Z" },
    { value: "nameDesc", label: "Tên Z → A" },
  ];

  const headers = {
    "Content-Type": "application/json",
  };

  const fetchCards = async (params) => {
    setIsLoadingCards(true);
    try {
      const res = await getListCard(headers, params);
      const normalizedCards = extractCardList(res?.data);

      const cardsWithLinks = await Promise.all(
        normalizedCards.map(async (card) => {
          const productLink = card?.registerDeeplink?.link;
          const cardId =
            card?.id || card?.cardId || card?.cardCode || card?.code;

          if (!cardId || !productLink) {
            return card;
          }

          try {
            const trackingRes = await getTrackingLink(headers, cardId);
            const data = trackingRes?.data ?? [];
            if (!Array.isArray(data) || data.length === 0) {
              return card;
            }

            const matchedLink = data.find((item) => item.link === productLink);
            if (matchedLink) {
              // Ưu tiên shortLink, nếu không có thì dùng linkAff
              const trackingLink = matchedLink?.shortLink || matchedLink?.linkAff;
              if (trackingLink) {
                return {
                  ...card,
                  registerDeeplink: {
                    ...card.registerDeeplink,
                    link: trackingLink,
                  },
                };
              }
            }
          } catch (error) {
            console.error(
              `Failed to fetch tracking link for card ${cardId}:`,
              error
            );
          }

          return card;
        })
      );

      setCards(cardsWithLinks);
      setActivePage(1);
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Không thể tải danh sách thẻ. Vui lòng thử lại sau."
      );
      setCards([]);
    } finally {
      setIsLoadingCards(false);
    }
  };

  const totalPages = Math.ceil(filteredCards.length / CARDS_PER_PAGE) || 1;
  const paginatedCards = filteredCards.slice(
    (activePage - 1) * CARDS_PER_PAGE,
    activePage * CARDS_PER_PAGE
  );

  useEffect(() => {
    fetchCards({
      displayStreamCode: "DS04",
      status: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activePage > totalPages) {
      setActivePage(totalPages || 1);
    }
  }, [totalPages, activePage]);

  return (
    <section className="register-mothe-section">
      <div className="container">
        <h2 className="register-mothe-title">Đăng ký mở thẻ online</h2>
        <p className="register-mothe-description">
          Không phí ẩn, an toàn, lãi nhẹ, miễn phí phát hành
        </p>
        <div className="content-mothe">
          <div className="filter-mothe">
            <h3 className="filter-title">Tìm thẻ tín dụng phù hợp</h3>

            <div className="filter-tabs">
              <button
                className={`tab ${activeTab === "Tất cả" ? "active" : ""}`}
                onClick={() => {
                  setActiveTab("Tất cả");
                  setActivePage(1);
                }}
              >
                Tất cả
              </button>

              <button
                className={`tab ${
                  activeTab === "Tỉ lệ phê duyệt cao" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("Tỉ lệ phê duyệt cao");
                  setActivePage(1);
                }}
              >
                Tỉ lệ phê duyệt cao
              </button>

              <button
                className={`tab ${activeTab === "Rút tiền" ? "active" : ""}`}
                onClick={() => {
                  setActiveTab("Rút tiền");
                  setActivePage(1);
                }}
              >
                Rút tiền
              </button>

              <button
                className={`tab ${
                  activeTab === "Chi tiêu Online" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("Chi tiêu Online");
                  setActivePage(1);
                }}
              >
                Chi tiêu Online
              </button>

              <p
                className="reset-link"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab("Tất cả");
                  setSalaryInput("");
                  setAgeInput("");
                  setSelectedArea(null);
                  setSelectedSort(null);
                  setActivePage(1);
                }}
              >
                Đặt lại
              </p>
            </div>

            <div className="filter-inputs">
              <div className="search-input">
                <label>Thu nhập hàng tháng của bạn (VNĐ):</label>
                <input
                  type="text"
                  className="salary-income"
                  value={salaryInput}
                  onChange={(e) => {
                    setSalaryInput(e.target.value);
                    setActivePage(1);
                  }}
                  placeholder="Ví dụ: 10.000.000"
                />
              </div>
              <div className="search-input">
                <label>Tuổi của bạn:</label>
                <input
                  type="text"
                  className="age"
                  value={ageInput}
                  onChange={(e) => {
                    setAgeInput(e.target.value);
                    setActivePage(1);
                  }}
                  placeholder="Ví dụ: 28"
                />
              </div>
              <div className="search-select">
                <label>Khu vực mở thẻ:</label>
                <Select
                  placeholder="Lựa chọn"
                  options={optionArea}
                  styles={customSelect}
                  className="card-mine-area"
                  value={selectedArea}
                  onChange={(option) => {
                    setSelectedArea(option);
                    setActivePage(1);
                  }}
                  isClearable
                />
              </div>
              <div className="search-select">
                <label>Sắp xếp theo:</label>
                <Select
                  placeholder="Lựa chọn"
                  options={sortBy}
                  styles={customSelect}
                  className="sort-by"
                  value={selectedSort}
                  onChange={(option) => {
                    setSelectedSort(option);
                    setActivePage(1);
                  }}
                  isClearable
                />
              </div>
            </div>
          </div>

          <div className="product-the">
            <div className="row row-the">
              {isLoadingCards && (
                <div className="col-12 text-center">
                  <p className="cards-loading">Đang tải danh sách thẻ...</p>
                </div>
              )}

              {!isLoadingCards && filteredCards.length === 0 && (
                <div className="col-12 text-center">
                  <p className="cards-empty">
                    Hiện chưa có thẻ phù hợp. Vui lòng quay lại sau.
                  </p>
                </div>
              )}

              {!isLoadingCards &&
                paginatedCards.map((card, index) => (
                  <CardProduct
                    key={
                      card?.id ??
                      card?.cardId ??
                      card?.cardCode ??
                      card?.code ??
                      card?.slug ??
                      index
                    }
                    card={card}
                    index={(activePage - 1) * CARDS_PER_PAGE + index}
                  />
                ))}
            </div>
          </div>
          {filteredCards.length > CARDS_PER_PAGE && (
            <div className="pagination-the">
              {Array.from({
                length: Math.ceil(filteredCards.length / CARDS_PER_PAGE),
              }).map((_, index) => (
                <span
                  key={`page-${index + 1}`}
                  className={`page-item ${
                    activePage === index + 1 ? "active" : ""
                  }`}
                  onClick={() => setActivePage(index + 1)}
                >
                  {index + 1}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="notificationModal"
        aria-hidden="true"
        aria-labelledby="notificationModalLabel"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="notificationModalLabel">
                Thông báo
              </h1>
            </div>
            <div className="modal-body">
              Thẻ sẽ hoạt động trong quý 4 năm 2025
            </div>
            <div className="modal-footer">
              <button className="btn btn-danger" data-bs-dismiss="modal">
                Đóng
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterCardSection;

